// Minimal stub for vk-bridge to allow web build without pulling real SDK.
// Methods resolve safely with defaults.

import { devError } from '../shared/lib/devLog';

type BridgeEventListener = (event: { detail?: any }) => void;

const listeners: Set<BridgeEventListener> = new Set();

async function send<T = any>(_method: string, _params?: Record<string, any>): Promise<T> {
  switch (_method) {
    case 'VKWebAppGetLaunchParams':
      return {} as T;
    case 'VKWebAppGetConfig':
      return { scheme: 'bright_light' } as T;
    default:
      return {} as T;
  }
}

function subscribe(listener: BridgeEventListener) {
  listeners.add(listener);
}

function unsubscribe(listener: BridgeEventListener) {
  listeners.delete(listener);
}

function __emit(event: any) {
  listeners.forEach((listener) => {
    try {
      listener({ detail: event });
    } catch (err) {
      devError('[vk-bridge stub] listener error', err);
    }
  });
}

export default {
  send,
  subscribe,
  unsubscribe,
  __emit,
};
